import {FeatureCollection, LineString} from "geojson"
import {Point as OLPoint} from "ol/geom"
import {Feature} from "ol"
import {GeoJSON} from "ol/format"
import {TNavObject} from "@ui/api/features"
import {LayerId} from "./"
import FeatureService from "./FeatureService"

export interface ILineService {
  addLines<T extends TNavObject>(lines: FeatureCollection<LineString, T>, layerId: LayerId): void
  toggleLayer(isVisible: boolean): void
}

export class LineService extends FeatureService implements ILineService {
  lineLayers = [LayerId.NAVLNE]

  addLines<T extends TNavObject>(lines: FeatureCollection<LineString, T>, layerId: LayerId): void {
    const formatter = new GeoJSON()
    const features = formatter.readFeatures(lines) as Feature<OLPoint>[]
    if (features.length > 0) {
      FeatureService.addFeatures(layerId, features)
    }
  }

  toggleLayer(isVisible: boolean) {
    this.lineLayers.forEach(layerId => FeatureService.getLayer(layerId)?.setVisible(isVisible))
  }
}

export default new LineService() as ILineService
